import React, { Component } from 'react';
import { DateInput } from "@blueprintjs/datetime";
import { Form, TextArea, Grid, Button, Header, Modal, Message, Icon } from 'semantic-ui-react';

function isNumber(n) {
    return !isNaN(parseFloat(n));
}
/**
 * Custom property filter for specific input types.
 * @param {any} propsInputType
 * @param {any} propsValue
 */
function processInput(propsInputType, propsValue) {
    let inputType = "text";

    if (propsInputType) {
        inputType = propsInputType;
    }

    let value = propsValue;
    let type = "text";
    let maxLength = 300;

    // todo add in decimals?
    if (inputType === "number" || inputType === "money" || inputType === "year" || inputType === "numberTwoDec"
        || inputType === "distanceft") {
        //console.log(isNumber(propsValue));
        if (parseFloat(propsValue) === 0) {
            value = "";

        }

        type = "number";

        if (inputType === "money") {
            //value = value;
            // ^ does nothing.... 06/09/2021
        }

    }

    if (inputType === "year" || inputType === "hwy") {
        maxLength = 4;
    }
    if (inputType === "decimal") {
        if (isNumber(propsValue)) {
            value = propsValue;
        } else {
            value = "";
        }
    }

    return {
        value, type, maxLength
    };
}

/**
 * Custom input type filter.
 * @param {any} e
 * @param {any} inputType
 * @param {any} onChangeProps
 */
function onChangeFilter(e, inputType, onChangeProps) {
    let value = e.target.value;

    // can do whatever we need here
    if (inputType === "year" || inputType === "hwy") {
        e.target.value = value.substring(0, 4);
    }
    if (inputType === "numberUnder300") {
        if (isNumber(value)) {
            e.target.value = (value >= 0 && value <= 300) ? parseFloat(value) : value.substring(0, value.length - 1);
        }
        else {

            e.target.value = "";
        }
    }
    if (inputType === "numberUnder100") {
        if (isNumber(value)) {
            e.target.value = (value >= 0 && value < 100) ? parseFloat(value) : value.substring(0, value.length - 1);
        }
        else {
            //console.log(isNumber(value));
            e.target.value = "";
        }
    }
    onChangeProps(e);
}


export default class Utilities {
    static doStuff() {
        console.log('did stuff');
    }
}

export class PtInput extends Component {
    // eslint-disable-next-line
    constructor(props) {
        super(props);
    }

    render() {
        const { value, type, maxLength } = processInput(this.props.inputType, this.props.value);

        return (
            <label className="pt-label pt_input_text" style={{ display: this.props.display }}>
                <span className="pt-text-muted pt-small" >{this.props.label}</span>
                <div className="pt-input-group">
                    {this.props.inputType === "money" && <span className="pt-icon pt-icon-dollar"></span>}

                    <input className="pt-input pt-small pt_input_width" maxLength={maxLength}
                        disabled={this.props.disabled}

                        value={value}

                        name={this.props.name}
                        onChange={e => onChangeFilter(e, this.props.inputType, this.props.onChange)}
                        type={type}
                        placeholder={this.props.placeholder ?
                            this.props.placeholder : "Text input"}
                        dir="auto" />

                    {/*this.props.inputType === "distanceft" && <button className="pt-button pt-minimal">ft.</button>*/}
                </div>
            </label>
        );
    }
}

export class PtInputShort extends Component {
    // eslint-disable-next-line
    constructor(props) {
        super(props);
    }

    render() {
        const { value, type, maxLength } = processInput(this.props.inputType, this.props.value);

        return (
            <label className="pt-label pt_input_text_short" style={{ display: this.props.display }}>
                <span className="pt-text-muted pt-small" >{this.props.label}</span>
                <div className="pt-input-group">
                    {this.props.inputType === "money" && <span className="pt-icon pt-icon-dollar"></span>}

                    <input className="pt-input pt-small pt_input_width" maxLength={maxLength}
                        disabled={this.props.disabled}

                        value={value}

                        name={this.props.name}
                        onChange={e => onChangeFilter(e, this.props.inputType, this.props.onChange)}
                        type={type}
                        placeholder={this.props.placeholder ?
                            this.props.placeholder : "Text input"}
                        dir="auto" />

                    {/*this.props.inputType === "distanceft" && <button className="pt-button pt-minimal">ft.</button>*/}
                </div>
            </label>
        );
    }
}

export class PtInputConditionTab extends Component {
    // eslint-disable-next-line
    constructor(props) {
        super(props);
    }

    render() {
        const { value, type, maxLength } = processInput(this.props.inputType, this.props.value);

        return (
            <label className="pt-label pt_input_text" style={{ display: this.props.display }}>
                <span className="pt-text-muted pt-small" >{this.props.label}</span>
                <div className="pt-input-group">
                    {this.props.inputType === "money" && <span className="pt-icon pt-icon-dollar"></span>}

                    <input className={"pt-input pt_input_width " + this.props.whichInput} maxLength={maxLength}
                        disabled={this.props.disabled}

                        value={value}

                        name={this.props.name}
                        onChange={e => onChangeFilter(e, this.props.inputType, this.props.onChange)}
                        type={type}
                        placeholder={this.props.placeholder ?
                            this.props.placeholder : "Text input"}
                        dir="auto" />

                    {/*this.props.inputType === "distanceft" && <button className="pt-button pt-minimal">ft.</button>*/}
                </div>
            </label>
        );
    }
}

export class PtInputNextToEachOther extends Component {
    render() {
        const { value, type, maxLength } = processInput(this.props.inputType, this.props.value);

        return (
            <label className="pt-label pt_input_text">
                <span className="pt-text-muted pt-small" >{this.props.label}</span>
                <div className="estimate_group">
                    <span className="pt-input-group pt_input_span">
                        {this.props.inputType === "money" && <span className="pt-icon pt-icon-dollar"></span>}

                        <input className="pt-input pt-small pt-fill" type={type}
                            value={value} name={this.props.name}
                            onChange={e => onChangeFilter(e, this.props.inputType, this.props.onChange)}
                            disabled={this.props.disabled} maxLength={maxLength}
                            placeholder={this.props.placeholder} dir="auto" />

                        {/*this.props.inputType === "distanceft" && <button className="pt-button pt-minimal">ft.</button>*/}
                    </span>
                    <span style={{ float: 'right' }}>
                        <input style={{ width: '100px' }} className="pt-input pt-small pt-fill" type={type}
                            value={value} name={this.props.name}
                            onChange={e => onChangeFilter(e, this.props.inputType, this.props.onChange)}
                            disabled={this.props.disabled} maxLength={maxLength}
                            placeholder={this.props.placeholder} dir="auto" />
                    </span>
                </div>
                <div style={{ clear: 'both' }} />
            </label>
        );
    }
}

export class PtInputIcon extends Component {
    // eslint-disable-next-line
    constructor(props) {
        super(props);
        // props required:
        // color?
        // icon div
        // label
    }

    render() {
        return (
            <label className="pt-label pt_input_icon">
                <span className="pt-text-muted pt-small">{this.props.label}</span>
                <div className={"pt-input-group pt_inputIcon_width"}>
                    {/*Todo: make button clickable to copy and focus.
                    <a className="grow pt-icon pt-icon-map-marker" style={{ color: this.props.color }}></a>
                    */}
                    {!this.props.disabled && this.props.icon}
                    <input disabled={this.props.disabled} className={`pt-input ${this.props.inputColor} pt-small pt-fill`}
                        readOnly type="text" placeholder="Map Input" dir="auto"
                        value={renderStringToFixed(this.props.value, 7)} />
                    {!this.props.disabled && this.props.edit}
                </div>
            </label>
        );
    }
}


export class PtInputIconElevation extends Component {
    // eslint-disable-next-line
    constructor(props) {
        super(props);
        // props required:
        // color?
        // icon div
        // label
    }

    render() {
        return (
            <Grid>
                <Grid.Row style={{ padding: 0 }}>
                    <Grid.Column width={9} style={{ paddingRight: 0, marginBottom: 0 }}>
                        <label className="pt-label" >
                            <span className="pt-text-muted pt-small">{this.props.label}</span>
                            <div className={"pt-input-group "}>
                                {!this.props.disabled && this.props.icon}
                                <input disabled={this.props.disabled} className={`pt-input ${this.props.inputColor} pt-small`}
                                    readOnly type="text" placeholder="Map Input" dir="auto"
                                    value={this.props.value} />
                                {!this.props.disabled && this.props.edit}
                            </div>
                        </label>
                    </Grid.Column>
                    <Grid.Column width={6} style={{ paddingRight: 0, marginBottom: 0 }}>
                        <label className="pt-label" >
                            <span className="pt-text-muted pt-small">Elevation ft.</span>
                            <div className={"pt-input-group "}>
                                <input disabled={this.props.disabled} className={`pt-input ${this.props.inputColor} pt-small`}
                                    placeholder="Elevation ft." dir="auto" name={this.props.name}
                                    value={this.props.valueElevation} type="number"
                                    onChange={e => onChangeFilter(e, "number", this.props.onChange)} />
                            </div>
                        </label>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        );
    }
}


export class PtInputIconWaypoint extends Component {
    // eslint-disable-next-line
    constructor(props) {
        super(props);
    }

    render() {

        return (
            <label className="pt-label">
                <span className="pt-text-muted pt-small">{this.props.label}</span>
                <div className={"pt-input-group pt_inputIcon_width"}>
                    {/*Todo: make button clickable to copy and focus.
                <a className="grow pt-icon pt-icon-map-marker" style={{ color: this.props.color }}></a>
                */}
                    {!this.props.disabled && this.props.icon}
                    <input disabled={this.props.disabled} className={`pt-input ${this.props.inputColor} pt-small pt-fill`}
                        readOnly type="text" placeholder="Map Input" dir="auto"
                        value={renderStringToFixed(this.props.value, 7)} />
                    {!this.props.disabled && this.props.button}
                </div>
            </label>
        );
    }
}

function renderStringToFixed(val, digits) {
    const nums = val.split(',');
    let result = parseFloat(nums[0]).toFixed(digits) + "," + parseFloat(nums[1]).toFixed(digits);
    //console.log(result);
    return result;
}

export class PtSelect extends Component {
    // eslint-disable-next-line
    constructor(props) {
        super(props);
        // label
        // Options: key, value, label, isSelected
    }

    render() {
        const options = this.props.options.map((item) =>
            <option key={item.key} value={item.value}> {item.label}</option>);

        let dv = 0;
        if (this.props.defaultVal) {
            dv = this.props.defaultVal;
            //console.log(`default: ${dv} `);
        }

        return (
            <label className="pt-label" style={{ display: this.props.display }}>
                {this.props.label}
                <div className="pt-select pt_select_width">
                    <select value={dv} onChange={this.props.onChange} name={this.props.name} disabled={this.props.disabled}>
                        {options}
                    </select>
                </div>
            </label>
        );
    }
}

export class TextSelect extends Component {
    // eslint-disable-next-line
    constructor(props) {
        super(props);
        if(this.props.width == undefined){
            this.width="150px";
        }else{
            this.width = this.props.width;
        }
        // label
        // Options: key, value, label, isSelected
    }

    render() {
        const options = this.props.options.map((item) =>
            <option key={item.key} data-value={item.value} value={item.label}></option>);

        return (
            <label className="pt-label" style={{ display: this.props.display }}>
                {this.props.label}

                <input className="CodeInput" list={this.props.id} type="text" placeholder={this.props.placeholder} disabled={this.props.disabled} onChange={this.props.onChange} style={{ 'width': this.width }} name={this.props.name}></input>
                <datalist id={this.props.id} >
                    {options}
                </datalist>
                <input type="hidden" name={this.props.name} id="PanelCode-hidden"></input>
            </label>
        );
    }
}

export class PtInputAndSelectAndEstimate extends Component {
    render() {
        const { value, type, maxLength } = processInput(this.props.inputType, this.props.value);

        const options = this.props.options.map((item) =>
            <option key={item.key} value={item.value}> {item.label}</option>);

        let dv = 0;
        if (this.props.defaultVal) {
            dv = this.props.defaultVal;
            //console.log(`default: ${dv} `);
        }

        return (
            <label className="pt-label pt_input_text">
                <span className="pt-text-muted pt-small" >{this.props.label}</span>
                <div className="estimate_group">
                    <span className="pt-input-group pt_input_span_inline">
                        {this.props.inputType === "money" && <span className="pt-icon pt-icon-dollar"></span>}

                        <input className="pt-input pt-small pt-fill" type={type}
                            value={value} name={this.props.name}
                            onChange={e => onChangeFilter(e, this.props.inputType, this.props.onChange)}
                            disabled={this.props.disabled} maxLength={maxLength}
                            placeholder={this.props.placeholder} dir="auto" />

                        {/*this.props.inputType === "distanceft" && <button className="pt-button pt-minimal">ft.</button>*/}
                    </span>
                    <span className="pt-select pt_select_inline">
                        <select value={dv} name={this.props.name + "Type"} onChange={this.props.onChange} disabled={this.props.disabled}>
                            {options}
                        </select>
                    </span>
                    <span style={{ float: 'right' }}>
                        <PtColor defaultVal={this.props.estimated} name={this.props.name + "Est"}
                            onChange={this.props.onChange} disabled={this.props.disabled} />
                    </span>
                </div>
                <div style={{ clear: 'both' }} />
            </label>
        );
    }
}

export class PtInputAndEstimate extends Component {
    render() {
        const { value, type, maxLength } = processInput(this.props.inputType, this.props.value);

        return (
            <label className="pt-label pt_input_text">
                <span className="pt-text-muted pt-small" >{this.props.label}</span>
                <div className="estimate_group">
                    <span className="pt-input-group pt_input_span">
                        {this.props.inputType === "money" && <span className="pt-icon pt-icon-dollar"></span>}

                        <input className="pt-input pt-small pt-fill" type={type}
                            value={value} name={this.props.name}
                            onChange={e => onChangeFilter(e, this.props.inputType, this.props.onChange)}
                            disabled={this.props.disabled} maxLength={maxLength}
                            placeholder={this.props.placeholder} dir="auto" />

                        {/*this.props.inputType === "distanceft" && <button className="pt-button pt-minimal">ft.</button>*/}
                    </span>
                    <span style={{ float: 'right' }}>
                        <PtColor defaultVal={this.props.estimated} name={this.props.name + "Est"}
                            onChange={this.props.onChange} disabled={this.props.disabled} />
                    </span>
                </div>
                <div style={{ clear: 'both' }} />
            </label>
        );
    }
}

export class PtSelectAndEstimate extends Component {
    // eslint-disable-next-line
    constructor(props) {
        super(props);
        // label
        // Options: key, value, label, isSelected
    }

    render() {
        const options = this.props.options.map((item) =>
            <option key={item.key} value={item.value}> {item.label}</option>);

        let dv = 0;
        if (this.props.defaultVal) {
            dv = this.props.defaultVal;
            //console.log(`default: ${dv} `);
        }

        // TODO: add color to database as field!
        return (
            <label className="pt-label">
                {this.props.label}
                <div className="estimate_group">
                    <span className="pt-select pt_select_span">
                        <select value={dv} name={this.props.name} onChange={this.props.onChange} disabled={this.props.disabled}>
                            {options}
                        </select>
                    </span>
                    <span style={{ float: 'right' }}>
                        <PtColor defaultVal={this.props.estimated} name={this.props.name + "Est"}
                            onChange={this.props.onChange} disabled={this.props.disabled} />
                    </span>
                </div>
                <div style={{ clear: 'both' }} />
            </label>
        );
    }
}

// Color dropdown Used for estimated values
export class PtColor extends Component {
    // eslint-disable-next-line
    constructor(props) {
        super(props);
    }

    render() {
        const colorOptions = [
            { key: 0, value: 0, color: "#AAFE98", label: "green - Measured/Plans", isSelected: true },
            { key: 1, value: 1, color: "#FFFC47", label: "yellow - Estimated(High Confidence)", isSelected: false },
            { key: 2, value: 2, color: "#FF6767", label: "red - Estimated(Low Confidence)", isSelected: false },
        ]

        const options = colorOptions.map((item) =>
            <option key={item.key} value={item.value} style={item.style}> {item.label}</option>);

        let dv = 0;
        if (this.props.defaultVal) {
            dv = this.props.defaultVal;
        }

        return (
            <span className="pt-select" style={{ width: 32 }}>
                <select style={{ background: colorOptions[dv].color }} onChange={this.props.onChange} value={dv}
                    disabled={this.props.disabled} name={this.props.name}>
                    {options}
                </select>
            </span>
        );
    }
}

export class PtTextBox extends Component {
    // eslint-disable-next-line
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <label className="pt-label" style={{ display: this.props.display }}>
                <span className="pt-text-muted pt-small">{this.props.label}</span>
                <div className="pt-input-group">
                    <Form className="pt_text_area" >
                        <TextArea placeholder='Text input' rows={this.props.rows} disabled={this.props.disabled}
                            value={this.props.value} name={this.props.name} onChange={this.props.onChange} />
                    </Form>
                </div>
            </label>
        );
    }
}

export class PtModalText extends Component {
    // eslint-disable-next-line
    constructor(props) {
        super(props);
    }

    render() {
        return <div></div>;
    }
}

export class PtDateInput extends Component {
    // eslint-disable-next-line
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <label className="pt-label pt_input_text" style={{ display: this.props.display }}>
                <span>{this.props.label}</span>
                <div className="pt-input-group pt_date_input">
                    <DateInput popoverProps={{ inline: false }} disabled={this.props.disabled}
                        value={this.props.value} minDate={this.props.minDate} maxDate={this.props.maxDate} onChange={this.props.onChange} name={this.props.name} />
                </div>
            </label>
        );
    }
}

export class PtRadio extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const { value } = this.props;

        const options = this.props.options.map((item) =>
            <Form.Radio key={item.key} label={item.label} value={item.value} checked={value === item.value} disabled={this.props.disabled}
                onChange={this.props.onChange} name={this.props.name} />);

        return (
            <label className="pt-label pt_input_text">
                <span>{this.props.label}</span>
                <div className="pt-input-group">
                    <Form>
                        <Form.Group inline >
                            {options}
                        </Form.Group>
                    </Form>
                </div>
            </label>
        );
    }
}


// use this class for validating manual coordinates
// call example: 
//
//  <EditGeographicPoint  originalCoords={oc} updateCoordinate={(coordPair) => { this.setSate({ startPos: coordPair }); }} />
//
export class EditGeographicPoint extends Component {

    // initialize coordinate split. program should store raw coordinate string. I'm probably too lazy to standardize this for now.
    constructor(props) {
        super(props);
        let numPairs = this.props.originalCoords.split(',');

        this.state = {
            lat: parseFloat(numPairs[0]),
            lng: parseFloat(numPairs[1]),
            isInputValid: true
        };
    }

    // main render function
    render() {

        const openModal = () => { this.setState({ modalOpen: true }) };

        return (
            <Modal
                trigger={<button className="pt-button pt-minimal pt-intent-primary pt-icon-edit"
                    onClick={() => {
                        // edit
                        openModal();
                        // console.log("manual edit mode clicked");
                    }}></button>}

                open={this.state.modalOpen}
                onClose={this.handleClose}
                basic
                size='small'>

                <Header icon='browser' content='Edit Geography Point' />

                {!this.state.isInputValid && <Message error basic header='Your input format or range was invalid!' />}

                <Modal.Content>
                    <Form inverted>
                        <Form.Group widths='equal'>
                            <Form.Input type="number" fluid label='Lat' placeholder='latitude' value={this.state.lat} onChange={this.onInputChange} name="lat" />
                            <Form.Input type="number" fluid label='Lng' placeholder='longitude' value={this.state.lng} onChange={this.onInputChange} name="lng" />
                        </Form.Group>
                    </Form>
                </Modal.Content>

                <Modal.Actions>
                    <Button color='green' onClick={this.validate} inverted>
                        <Icon name='checkmark' />Validate
                    </Button>
                    <Button color='red' onClick={this.revertEdit} inverted>
                        <Icon name='checkmark' />Cancel
                    </Button>
                </Modal.Actions>
            </Modal>);
    }

    // Validate coordinate pairs.
    validate = (e) => {
        console.log('validated input!');

        let valid = true;

        console.log(this.state);

        // validating input goes here.
        if (parseFloat(this.state.lat) <= -90 || parseFloat(this.state.lat) >= 90) {
            valid = false;
        }

        if (parseFloat(this.state.lng) <= -180 || parseFloat(this.state.lng) >= 180) {
            valid = false;
        }

        if (valid) {
            this.props.updateCoordinate({ lat: this.state.lat, lng: this.state.lng });
            this.closeModal(e);

        }
        else {
            this.setState({ isInputValid: false });
        }
    }

    // revert if the user clicks cancel
    revertEdit = (e) => {
        let numPairs = this.props.originalCoords.split(',');

        this.setState({
            lat: parseFloat(numPairs[0]),
            lng: parseFloat(numPairs[1]),
        });

        this.closeModal(e);
    }

    closeModal = (e) => {
        this.setState({ modalOpen: false });
    }

    onInputChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: parseFloat(value) });
    }
}



// WEBPACK FOOTER //
// ./src/grit-utilities.js